document.addEventListener( 'DOMContentLoaded', function () {
  const participantSections = document.querySelectorAll( '.participants' );
  const itemHiddenClass = 'participants-hidden';
  const itemHiddenSelect = '.' + itemHiddenClass;

  participantSections.forEach( section => {
    const showMoreBtn = section.querySelector( '.load-more__show-more-wrap .button--outline' );
    const allParticipants = section.querySelectorAll( '.participants__item' );
    const seenCountEl = section.querySelector( '.load-more-seen-count' );
    const progressBarEl = section.querySelector( '.load-more__progress-bar' );
    const participantsList = section.querySelector( '.participants__list' );
    const loadMoreBar = section.querySelector( '.load-more' );

    if (!allParticipants.length) return;

    function getVisibleCount() {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 768) return 2;
      if (screenWidth <= 1024) return 3;
      return 4;
    }

    function initParticipantsView() {
      const initialVisible = getVisibleCount() * 7;
      if ( allParticipants.length <= initialVisible) {
        loadMoreBar.style.display = 'none';
        participantsList.classList.add( 'participants__list--no-hidden' );
      }
      allParticipants.forEach( (el, index) => {
        if (index >= initialVisible) {
          el.classList.add( itemHiddenClass );
        } else {
          el.classList.remove( itemHiddenClass );
        }
      } );

      updateProgress();
      if (section.querySelectorAll( itemHiddenSelect ).length === 0 && showMoreBtn) {
        showMoreBtn.classList.add( 'participants-button--hidden' );
      } else if (showMoreBtn) {
        showMoreBtn.classList.remove( 'participants-button--hidden' );
      }
    }

    function updateProgress() {
      const total = allParticipants.length;
      const visible = total - section.querySelectorAll( itemHiddenSelect ).length;
      if (seenCountEl) seenCountEl.textContent = visible;
      if (progressBarEl) progressBarEl.style.width = (visible / total * 100) + '%';
    }

    initParticipantsView();

    if (showMoreBtn) {
      showMoreBtn.addEventListener( 'click', function () {
        const hiddenParticipants = section.querySelectorAll( itemHiddenSelect );

        hiddenParticipants.forEach( (el) => {
          el.classList.remove( itemHiddenClass );
        } );

        updateProgress();

        if (section.querySelectorAll( itemHiddenSelect ).length === 0) {
          showMoreBtn.classList.add( 'participants-button--hidden' );
          participantsList.classList.add( 'participants__list--no-hidden' );
        }
      } );
    }

    window.addEventListener( 'resize', () => {
      initParticipantsView();
    } );
  } );
} );
